module.exports = __webpack_public_path__ + "assets/img/29_250.fa4802c3.jpg";